import { ApplicationType } from '@wix/editor-application';
import { EnvType, IApiHostConfig } from './common';

export const Public = () => true;
export const Private = () => false;
export const Frame = (config: IApiHostConfig) =>
  [EnvType.Frame].includes(config.env);

export const Addon = (config: IApiHostConfig) =>
  config.type === ApplicationType.EditorAddon &&
  [EnvType.Worker, EnvType.Frame].includes(config.env);
